import { Outlet } from 'react-router-dom'

export default function Cashouts() {
    return (
        <Outlet />
    )
}
